import { Comments } from "../../services";
import { createRestSlices, applyReducers, Status, Response } from './rest';
import { ActionPayload } from '..';
import Comment from '../../models/Comment';
import { removeFromList, upsertList } from './remoteUpdate';
import { Dispatch } from 'react';

const {
    initialState,
    createReducer, startCreateReducer,
    getReducer, listReducer,
    updateReducer, deleteReducer,
    createAction, startCreateAction,
    getAction, listAction,
    updateAction, deleteAction,
} = createRestSlices(Comments);

const UPDATE = 'yoda/mercure/REMOTE_UPDATE';
const onRemoteUpdateReducer = (state = initialState, action: ActionPayload) => {
    if (action.type !== UPDATE)
        return state;

    const { update: { data, type }} = action;
    switch (type) {
        case 'comment.created':
            return {
                ...state,
                comments: upsertList(state.comments, data, (payload) => new Comment(payload), true)
            };
        case 'comment.updated':
            return {
                ...state,
                comments: upsertList(state.comments, data, (payload) => new Comment(payload)),
                comment: state.comment?._id === data._id ? new Comment(data) : state.comment
            };
        case 'comment.deleted':
            return {
                ...state,
                comments: removeFromList(state.comments, data._id),
                comment: state.comment?._id === data._id ? null : state.comment
            };
        default:
            return state;
    }
};

const TOGGLE_REACTION         = 'yoda/comment/TOGGLE_REACTION';
const UPDATING_ITEM_SUCCESS   = 'yoda/comment/UPDATING_ITEM_SUCCESS';
const TOGGLE_REACTION_FAILURE = 'yoda/comment/TOGGLE_REACTION_FAILURE';

const toggleReactionReducer = (state = initialState, action: ActionPayload) => {
    switch (action.type) {
        case TOGGLE_REACTION:
            return {
                ...state,
                loadingOne: 'pending' as Status,
                loadingError: null
            };
        case TOGGLE_REACTION_FAILURE:
            return {
                ...state,
                loadingOne: 'failed' as Status,
                loadingError: action.error
            };
        default:
            return state;
    }
};

const toggleCommentReactionAction = (commentId: string, emoji: string) => {
    return (dispatch: Dispatch<any>) => {
        dispatch({ type: TOGGLE_REACTION });
        return Comments.toggleReaction(commentId, emoji)
            .then((data: Response) => {
                if ("comment" in data) {
                    const { comment } = data;
                    // Reuse update success so change.comments stays in sync.
                    dispatch({ type: UPDATING_ITEM_SUCCESS, comment });
                    return comment;
                }
            })
            .catch((error: Error) => {
                dispatch({ type: TOGGLE_REACTION_FAILURE, error: error.message });
                throw error;
            });
    };
};

/* Export reducer */
/* eslint import/no-anonymous-default-export: [2, {"allowArrowFunction": true}] */
export default (state = initialState, action: ActionPayload) => {
    return applyReducers(state, action, [
        createReducer, startCreateReducer,
        getReducer, listReducer,
        updateReducer, deleteReducer,
        onRemoteUpdateReducer,
        toggleReactionReducer
    ]);
}

/* Export CRUD actions */
export const createComment         = createAction;
export const startCreateComment    = startCreateAction;
export const loadComment           = getAction;
export const loadComments          = listAction;
export const updateComment         = updateAction;
export const deleteComment         = deleteAction;
export const toggleCommentReaction = toggleCommentReactionAction;
